import { render, staticRenderFns } from "./SalaryTypeFilterSidebar.vue?vue&type=template&id=52f63d2c&"
import script from "./SalaryTypeFilterSidebar.vue?vue&type=script&lang=js&"
export * from "./SalaryTypeFilterSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SalaryTypeFilterSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports